import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="py-32 text-center" data-testid="not-found-page">
      <h1 className="font-serif text-5xl text-[#39251D]">Pagina non trovata</h1>
      <Link to="/" data-testid="not-found-home-link" className="inline-block mt-8 text-xs uppercase tracking-[0.2em] border-b border-[#956842] pb-1">Torna alla home</Link>
    </div>
  );
}
